<div>
    <button *ngIf="(documents$ | async)?.length" mat-flat-button color="accent" class="country__wide-button"
          [routerLink]="['/documents']" [queryParams]="{country: (country$ | async)?.iso2}" >
      <mat-icon svgIcon="document" inline="true"></mat-icon>
      <div class="country__wide-button-title">Documents</div>
    </button>
    <button *ngIf="!(documents$ | async)?.length" mat-flat-button color="accent" class="country__wide-button"
          [routerLink]="['/documents']" [queryParams]="{country: 'global'}" >
      <mat-icon svgIcon="document" inline="true"></mat-icon>
      <div class="country__wide-button-title">Documents</div>
    </button>
</div>
